module.exports = __webpack_public_path__ + "img/hanyan.a74485ae.jpg";